﻿const SELECTED_IMAGE_ATTRIBUTE = "data-preview-selected-image";
const PREVIEW_IMAGE_ATTRIBUTE = "data-preview-image";
const PREVIEW_RADIO_ATTRIBUTE = "data-preview-image-radio";
const PREVIEW_FIELD_ATTRIBUTE = "data-preview-field";
const PREVIEW_SELECTED_VALUE_ATTRIBUTE = "data-preview-selected-value";
const IMAGE_API_ROUTE = "/ace-api/gift/preview";

window.addEventListener('load', () => {
    var queryStringElements = new Array();
    var selectedImage = document.querySelector(`[${SELECTED_IMAGE_ATTRIBUTE}]`);

    // Bind images to create a new preview with the selected image
    var designs = document.querySelectorAll(`[${PREVIEW_IMAGE_ATTRIBUTE}]`);

    // Bind radio buttons to create a new preview for ADA purposes
    var designRadios = document.querySelectorAll(`[${PREVIEW_RADIO_ATTRIBUTE}]`);
    [].forEach.call(designRadios, (designRadio) => {
        designRadio.addEventListener('change', function (obj) {
            // FIX: Get the radiobutton value (contain the URL image)
            let imageUrl = designRadio.value;
            // Search for the corresponding image using the value as src
            let designUpdate = document.querySelector(`[${PREVIEW_IMAGE_ATTRIBUTE}][src="${imageUrl}"]`);
            
            // Validate that image exists before update
            if (designUpdate) {
                updateSelectedDesign(designUpdate);
            }
        });
    });


    // Bind inputs to refresh preview image when they change text
    var inputs = document.querySelectorAll(`[${PREVIEW_FIELD_ATTRIBUTE}]`);
    [].forEach.call(inputs, (input) => {
        input.addEventListener("change", function (obj) {
            updateImagePreview(obj);
        });
    });

    // Initialize preview to the first image
    if (designs.length > 0) {
        updateSelectedDesign(designs[0]);
    }

    function updateSelectedDesign(selectedItem) {
        // Valide that selectedItem exists
        if (!selectedItem) {
            console.error('Selected item is null or undefined');
            return;
        }
        
        // set hidden field value to the new item
        var hiddenField = document.querySelector(`[${PREVIEW_SELECTED_VALUE_ATTRIBUTE}]`);
        var imageUrl = selectedItem.getAttribute('src');
        
        if (hiddenField && imageUrl) {
            hiddenField.value = imageUrl;
            
			// Update corresponding radio button for ADA purposes
            var radioButton = document.getElementById(imageUrl);
            if (radioButton) {
                radioButton.checked = true;
            }
        }

        updateImagePreview();
    }

    function updateImagePreview(event) {
        // Validate that selectedImage exists
        if (!selectedImage) {
            console.error('Selected image element not found');
            return;
        }
        
        // Update query string with current values
        var inputs = document.querySelectorAll(`[${PREVIEW_FIELD_ATTRIBUTE}]`);
        [].forEach.call(inputs, input => {
            appendToQueryString(input);
        });

        // Set image src to api route with query params applied
        var serializedQueryString = queryStringElements.join("&");
        selectedImage.src = `${IMAGE_API_ROUTE}?${serializedQueryString}`;
        queryStringElements = [];
    }

    function appendToQueryString(input) {
        // Get the query string param name from the preview field attribute value
        var paramName = input.getAttribute(PREVIEW_FIELD_ATTRIBUTE);
        var paramValue = input.value;
        if (paramName && paramValue) {
            queryStringElements.push(paramName + "=" + paramValue);
        }
    }
});